export enum TransactionType {
  TRANSFER = "TRANSFER",
  OFFER = "OFFER",
  PURCHASE = "PURCHASE",
}
